import "./DateRangePickerComponent.scss";
import React, {useCallback, useEffect, useState} from "react";

import {IDateRangePickerProps} from "../../../models/form-controls.model";
import LabelComponent from "../../label/LabelComponent";
import ErrorTextComponent from "../../error-text/ErrorTextComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {ImageConfig} from "../../../../constants";

// import 'react-calendar/dist/Calendar.css';

interface DateRangePickerComponentProps extends IDateRangePickerProps {
}

const DateRangePickerComponent = (props: DateRangePickerComponentProps) => {
    const {
        name,
        label,
        hasError,
        errorMessage,
        className,
        fullWidth,
        onChange,
        required,
        placeholder
    } = props;

    const showMonthDropdown = props.showMonthDropdown || true;
    const showYearDropdown = props.showYearDropdown || true;
    const peekNextMonth = props.peekNextMonth || true;
    const dropdownMode = props.dropdownMode || 'select';

    const [dateRange, setDateRange] = useState<any[]>([null, null]);
    const [startDate, endDate] = dateRange;

    const handleChange = useCallback((newValue: any | null) => {
        console.log(newValue);
        setDateRange(newValue)
        if (onChange) onChange(newValue);
    }, [onChange]);

    useEffect(() => {
        setDateRange([props.startDate ? props.startDate : null, props.endDate ? props.endDate : null]);
    }, [props.startDate, props.endDate]);

    return (

        <div className={`date-range-picker-component ${fullWidth ? "fullWidth" : ''}`}>
            {label && <LabelComponent title={label} required={required}/>}
            <div className={"date-picker-container"}>
                <DatePicker
                    className={`date-range-picker-field ${className}`}
                    placeholderText={placeholder}
                    selectsRange={true}
                    name={name}
                    startDate={startDate}
                    endDate={endDate}
                    showMonthDropdown={showMonthDropdown}
                    showYearDropdown={showYearDropdown}
                    peekNextMonth={peekNextMonth}
                    dropdownMode={dropdownMode}
                    dateFormat="MM/dd/yy"
                    onChange={(update) => {
                        handleChange(update);
                    }}
                    isClearable={true}
                />
                {!dateRange[0]  && <ImageConfig.CalendarIcon className="date-picker-icon" />}
            </div>
            {(errorMessage && hasError) && (
                <ErrorTextComponent error={errorMessage}/>
            )}
        </div>
    );

};

export default DateRangePickerComponent;
